export default __webpack_public_path__ + "static/refer-project-banner-7dba45cff9ad03b13dc09c3d8e3f0d5b.png";